import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Users, MessageCircle, KeyRound, TrendingUp, Sparkles, Home, FileText, Camera } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { t } from '@/i18n/translations';

const serviceIcons = [Home, MessageCircle, KeyRound, TrendingUp, Sparkles, Home, FileText, Camera];

const CosaOffriamo = () => {
  const { lang } = useLanguage();
  const c = t('cosaOffriamo', lang);
  const fadeIn = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6 } };

  return (
    <div className="bg-white pt-32 pb-16" data-testid="cosa-offriamo-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeIn} className="text-center mb-16">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#0A1312] mb-6" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{c.title}</h1>
          <p className="text-base md:text-lg text-[#0A1312] max-w-3xl mx-auto" style={{fontFamily: "'Satoshi', sans-serif"}}>{c.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {c.services.map((service, idx) => {
            const Icon = serviceIcons[idx];
            return (
              <motion.div key={service.title} {...fadeIn} transition={{ delay: idx * 0.1 }} className="bg-[#F7F9F9] p-8 border border-[#E2E8F0] rounded-sm hover:-translate-y-1 transition-transform" data-testid={`service-detail-${idx}`}>
                <Icon className="text-[#65c3ba] mb-4" size={36} strokeWidth={1.5} />
                <h2 className="text-2xl font-semibold text-[#0A1312] mb-3" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{service.title}</h2>
                <p className="text-[#0A1312] mb-4" style={{fontFamily: "'Satoshi', sans-serif"}}>{service.desc}</p>
                <ul className="space-y-2">
                  {service.features.map((f, fIdx) => (
                    <li key={`feature-${f.slice(0,15)}`} className="flex items-start text-[#0A1312] text-sm">
                      <span className="text-[#65c3ba] mr-2">&bull;</span>
                      <span style={{fontFamily: "'Satoshi', sans-serif"}}>{f}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>

      <motion.div {...fadeIn} className="relative overflow-hidden text-center" data-testid="cosa-offriamo-cta">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1772475329901-58f77a9625ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3YXJtJTIwbW9kZXJuJTIwYXBhcnRtZW50JTIwaW50ZXJpb3IlMjBjb3p5JTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3NzYwMzA1NTZ8MA&ixlib=rb-4.1.0&q=85')", backgroundAttachment: 'fixed' }} />
        <div className="absolute inset-0 bg-[#3e716c]/80" />
        <div className="relative z-10 py-16 px-4 text-white">
          <h2 className="text-2xl font-bold mb-4" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{c.ctaTitle}</h2>
          <p className="text-white/70 mb-8" style={{fontFamily: "'Satoshi', sans-serif"}}>{c.ctaText}</p>
          <Link to="/valutazione-gratuita">
            <Button className="bg-[#65c3ba] text-white hover:bg-white hover:text-[#3e716c] rounded-sm px-8 py-6 text-lg">{c.ctaBtn}</Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default CosaOffriamo;